import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'Service/api/api';
import { IRefusedOrderPostData } from 'Shared/Types/api';

export const getOrderList = createAsyncThunk(
  `order/getOrderList`,
  async ({ page, pageSize }: { page?: number; pageSize?: number }) => {
    try {
      const response = await api.order.getOrderList({ page, pageSize });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getOrder = createAsyncThunk(
  `order/getOrder`,
  async (id: number) => {
    try {
      const response = await api.order.getOrder(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getPreviousOrders = createAsyncThunk(
  `order/getPreviousOrders`,
  (id: number) => {
    try {
      return api.order.getPreviousOrders(id);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createOrder = createAsyncThunk(
  `order/createOrder`,
  async (data: any) => {
    try {
      const response = await api.order.createOrder(data);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const refuseOrder = createAsyncThunk(
  `bid/refuseBid`,
  async (data: IRefusedOrderPostData) => {
    try {
      const response = await api.order.refuseOrder(data);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);
